import firebase, { analytics } from '../firebase'

export const GA = (eventName: string, eventParams?: {[key: string]: any}, options?: firebase.analytics.AnalyticsCallOptions ): void => {
  // console.log('ANALYTICS:', eventName, eventParams)
  analytics.logEvent(eventName, eventParams, options)
}